import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/withRouter';
import Authentication from './../../session';
import { getBranchesLatest } from '../../../store/actions';
import { CancelRed, CrossInBox, GreenCheck, RightMarkInCircle } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import Service from '../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { BasicLazyParams } from '../../../utile';
import { Dialog } from 'primereact/dialog';
import '../styles.scss';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import BranchesApprovalHierarchy from '../../BaseDropdownComponents/BranchesApprovalHierarchy';

class RequestedStop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lazyParams: BasicLazyParams,
            requestedStopInfo: [],
            totalRecords: 0,
            remarks: '',
            isApproved: false,
            isRejected: false,
            selectedStopInfo: null,
            dropdownsData: null
        };
        this.service = new Service();
    }

    componentDidMount() { }

    setDropdownValues = (dropdownsData) => {
        this.setState({ dropdownsData, totalRecords: 0 }, () => this.getRequestedStopInfo());
    };

    getRequestedStopInfo = async () => {
        const { dropdownsData, lazyParams } = this.state;

        // branchIds is an array like [branchId], extract the first element
        const branchId = Array.isArray(dropdownsData?.branchIds)
            ? dropdownsData.branchIds[0]
            : dropdownsData?.branchIds;

        if (!branchId) return;

        let academicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/transport-stops-approval/get-pending-approvals?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=`;

        let payload = {
            academicYear,
            branchId,
            assignedHeirarchy: dropdownsData?.heirarchy
        };

        try {
            this.setState({ isLoading: true, requestedStopInfo: [] });
            const res = await this.service.post(url, payload, true);

            if (res && res.status && res.res?.status) {
                this.setState({
                    isLoading: false,
                    requestedStopInfo: res.res.records || [],
                    totalRecords: res.res.totalRecords || 0
                });
                if (!res.res?.records?.length) {
                    this.toast.show({ severity: 'info', summary: 'No records found.', detail: '', life: 3000 });
                }
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res.errMessage || 'Failed to fetch data', life: 3000 });
            }
        } catch (err) {
            this.setState({ isLoading: false });
            console.error(err);
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch stop approvals', life: 3000 });
        }
    };

    onHandleRequestedStopApprove = (rowData, isConfirmed) => {
        this.setState({
            isApproved: isConfirmed,
            isRejected: !isConfirmed,
            selectedStopInfo: rowData
        });
    };

    onApproveStops = (status) => {
        const { selectedStopInfo, remarks, dropdownsData } = this.state;
        this.setState({ isLoading: true });

        // Extract branchId from array
        const branchId = Array.isArray(dropdownsData?.branchIds)
            ? dropdownsData.branchIds[0]
            : dropdownsData?.branchIds;

        let payload = {
            ...selectedStopInfo,
            isApproved: status,
            remarks: remarks,
            handledBy: selectedStopInfo?.handledBy || [],
            levelAndBranchDetails: dropdownsData?.heirarchy?.adminLevels?.filter(
                (al) => al._id === branchId
            )
        };

        let url = `${baseUrlAdmin}/transport-stops-approval/approve-stops`;

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    this.setState({
                        isLoading: false,
                        isRejected: false,
                        isApproved: false,
                        selectedStopInfo: null,
                        remarks: ''
                    }, () => this.getRequestedStopInfo());
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: res.errMessage || 'Operation failed', life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    };

    onPage = (event) => {
        this.setState({ lazyParams: event }, () => this.getRequestedStopInfo());
    };

    render() {
        return (
            <div className="ma-main">
                <div className="col-span-1 my-3 mx-5">
                    <BranchesApprovalHierarchy
                        selectedValue={1}
                        setValues={this.setDropdownValues}
                        approvalType={'transportRoute'}
                    />
                </div>

                <DataTable
                    ref={(el) => (this.dt = el)}
                    value={this.state.requestedStopInfo}
                    dataKey="_id"
                    paginator
                    lazy
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.totalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    emptyMessage="No stop approvals found. Select a branch to view pending approvals."
                >
                    <Column
                        field="routeName"
                        sortable
                        bodyClassName="text-center"
                        header="Route Name"
                        alignHeader={'center'}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Area Name"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.stops?.[0]?.areaName || '-'}</p>}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Stop Name"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.stops?.[0]?.stopName || '-'}</p>}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Pick Up Time"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.stops?.[0]?.pickUpTime || '-'}</p>}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Drop Time"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.stops?.[0]?.dropTime || '-'}</p>}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Transport Fee"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.stops?.[0]?.transportFee || '-'}</p>}
                    />
                    <Column
                        sortable
                        bodyClassName="text-center"
                        header="Requested By"
                        alignHeader={'center'}
                        body={(rowData) => <p>{rowData?.requestRaisedUserName || '-'}</p>}
                    />
                    <Column
                        alignHeader={'center'}
                        bodyClassName="text-center"
                        header="Approve / Reject"
                        body={(rowData) => (
                            <div className="flex justify-content-center gap-2">
                                <div className="cursor-pointer" onClick={() => this.onHandleRequestedStopApprove(rowData, true)}>
                                    <GreenCheck />
                                </div>
                                <div className="cursor-pointer" onClick={() => this.onHandleRequestedStopApprove(rowData, false)}>
                                    <CancelRed />
                                </div>
                            </div>
                        )}
                    />
                </DataTable>

                {/* Reject Dialog */}
                <Dialog
                    visible={this.state.isRejected}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => (
                        <div className="mt-2 formHeadingInter">
                            <div className="mb-3">
                                <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                            </div>
                            <p style={{ fontWeight: 'bold', fontSize: 20 }}>Reject Stop</p>
                            <p style={{ fontSize: 14 }}>Stop Name: {this.state?.selectedStopInfo?.stops?.[0]?.stopName}</p>
                        </div>
                    )}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button
                                className="formSubmitButton px-4"
                                style={{ borderRadius: '10px', backgroundColor: '#BF0031', border: 'none' }}
                                onClick={() => this.onApproveStops(false)}
                            >
                                <p className="formSubmitButtonText">Reject</p>
                            </Button>
                            <Button
                                className="formCancelButton px-4"
                                style={{ backgroundColor: '#F4F5F6', border: 0 }}
                                onClick={() => this.setState({ isRejected: false, selectedStopInfo: null })}
                            >
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isRejected: false, selectedStopInfo: null })}
                >
                    <div className="m-3 pt-3">
                        <ClassetTextArea
                            width={'100%'}
                            style={{ height: '119px' }}
                            label={'Remarks:'}
                            placeholder="Enter remarks"
                            value={this.state.remarks}
                            onChange={(e) => this.setState({ remarks: e.target.value })}
                        />
                    </div>
                </Dialog>

                {/* Approve Dialog */}
                <Dialog
                    visible={this.state.isApproved}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => (
                        <div className="mt-2 formHeadingInter">
                            <div className="mb-3">
                                <RightMarkInCircle bgcolor={'#7CDD56'} color={'white'} />
                            </div>
                            <p style={{ fontWeight: 'bold', fontSize: 20 }}>Approve Stop</p>
                            <p style={{ fontSize: 14 }}>Stop Name: {this.state?.selectedStopInfo?.stops?.[0]?.stopName}</p>
                        </div>
                    )}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button
                                className="formSubmitButton px-4"
                                style={{ borderRadius: '10px', backgroundColor: '#7CDD56', border: 'none' }}
                                onClick={() => this.onApproveStops(true)}
                            >
                                <p className="formSubmitButtonText">Approve</p>
                            </Button>
                            <Button
                                className="formCancelButton px-4"
                                style={{ backgroundColor: '#F4F5F6', border: 0 }}
                                onClick={() => this.setState({ isApproved: false, selectedStopInfo: null })}
                            >
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isApproved: false, selectedStopInfo: null })}
                >
                    <div className="m-3 pt-3">
                        <ClassetTextArea
                            width={'100%'}
                            style={{ height: '119px' }}
                            label={'Remarks:'}
                            placeholder="Enter remarks"
                            value={this.state.remarks}
                            onChange={(e) => this.setState({ remarks: e.target.value })}
                        />
                    </div>
                </Dialog>

                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'),
    isLoading: state.boardsData.loading
});

export default connect(mapStateToProps, { getBranchesLatest })(Authentication(withRouter(RequestedStop)));
